<div fxFlex class="app-page" fxLayout="column">
  <app-navbar [ngStyle]="{'display': !isLogin ? 'none' : 'block' }"></app-navbar>
  <app-sidebar *ngIf="isLogin" class="active-sidebar"></app-sidebar>
  <ion-router-outlet></ion-router-outlet>
</div>